import Attendance from "../../pages/Attendance/Attendance";
import AdminBDMDashboard from "../../pages/BDMBoard/AdminBDMBoard";
import BDMBoard from "../../pages/BDMBoard/BDMBoard";
import BOMList from "../../pages/BillOfMaterials/BOMList";
import { CRM } from "../../pages/CRM/CRM";
import EpcCustomer from "../../pages/EPC/EpcCustomer";
import CseDashboard from "../../pages/EPCCustomerManager/CseDashboard";
import ImportExcel from "../../pages/ImportExcel/ImportExcel";
import Orders from "../../pages/Orders/Orders";
import PincodeManagement from "../../pages/Pincode/PincodeManagement";
import ProductPage from "../../pages/Products/product";
import SNManagement from "../../pages/SN/SNManagement";
import TaskManagement from "../../pages/TaskDashboard/TaskManagement";
import TelecallerBoard from "../../pages/TelecallerBoard/TelecallerBoard";
import UserManagement from "../../pages/User/UserManagement";
import Warehouse from "../../pages/Warehouse/Warehouse";
import WarrantyDetailsPage from "../../pages/WarrantyDetailsCustomers/WarrantyDetailsPage";
import DataEntryBoard from "../Lead/DataEntryBoard";
import WhatsAppInterface from "../WhatsAppChatting/WhatsAppInterface";
import WhatsAppAutoMessageSenderPage from "../../pages/WhatsappAutoMessageSender/WhatsAppAutoMessageSenderPage";
import ServiceManagement from "../../pages/ServiceManagement/ServiceManagement";
import PaymentValidation from "../PaymentValidation/PaymentValidation";
import TaskManagerDetail from "../TaskManagement/TaskManagerDetail";
import OptimizedQuotationManager from "../../pages/OptimizedQuotation/OptimizedQuotationManager";
import React from "react";
import LeadDetailsPage from "../../pages/LeadDetails/LeadDetails";
import BOMDetail from "../../pages/BillOfMaterials/BOMDetail";
import WarehouseHomeTab from "../../pages/Dispatch/Dispatch";
import PriceList from "../../pages/PriceList/PriceList";
import CampaignMessagesPage from "../../pages/WhatsappAutoMessageSender/CampaignsMsgsPage";

interface NavLinkItem {
  path: string;
  label?: string;
  component?: React.FC;
}

export const navComponentMap: Record<string, React.FC> = {
  Attendance,
  AdminBDMDashboard,
  BDMBoard,
  BOMList,
  CRM,
  EpcCustomer,
  CseDashboard,
  ImportExcel,
  Orders,
  PincodeManagement,
  ProductPage,
  SNManagement,
  TaskManagement,
  TelecallerBoard,
  UserManagement,
  Warehouse,
  WarrantyDetailsPage,
  DataEntryBoard,
  WhatsAppInterface,
  WhatsAppAutoMessageSenderPage,
  ServiceManagement,
  PaymentValidation,
  WarehouseHomeTab,
  PriceList,
};

export const commonRoutes: NavLinkItem[] = [
  {
    path: "/task-management/:taskId",
    component: TaskManagerDetail,
  },
  { path: "lead-details/:leadId", component: LeadDetailsPage },
  {
    path: "EpcCustomer/:customerId/customer-quotation/:leadId",
    component: () =>
      React.createElement(OptimizedQuotationManager, { from: "epcCustomer" }),
  },
  {
    path: "lead-details/:leadId/follow-up-epc",
    component: () =>
      React.createElement(OptimizedQuotationManager, { from: "leadDetails" }),
  },
  { path: "/boms/:bomId", component: BOMDetail },
  { path: "/price-list-boms/:bomId", component: BOMDetail },
  { path: "campaigns/:campaignId", component: CampaignMessagesPage },
];
